import { render, staticRenderFns } from "./description-panel.vue?vue&type=template&id=3f5cc484&"
import script from "./description-panel.vue?vue&type=script&lang=js&"
export * from "./description-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports